export const AUTHORIZED = "authorized";
export const GET_PROFILE = "getProfile";
export const GET_FULL_NAME = "getFullName";
export const GET_ACCESS_TOKEN = "getAccessToken";
